// extracted by mini-css-extract-plugin
export default {"uniqueBlock":"styles_uniqueBlock__Y51I9","container":"styles_container__GXfkX","title":"styles_title__sGRli","text":"styles_text__8sdo8","image":"styles_image__BYGG+"};